import { Preferences } from '@capacitor/preferences';

export const getStorageValue = async (storageKey) => {
  const { value } = await Preferences.get({ key: storageKey });

  return value;
};

export const removeStorage = async (storageKey) => {
  return await Preferences.remove({ key: storageKey });
};

export const setStorageObj = async (key, value) => {
  return await Preferences.set({
    key,
    value,
  });
};

export const getInvalidETagMessage = (message) => {
  return message.replace('ERROR_ETAG. ', '');
};

export const isETagInvalidError = (error) => {
  return !!error.response?.data.message.includes('ERROR_ETAG.');
};

export const handleETagError = (error) => (dispatch) => {
  if (isETagInvalidError(error)) {
    const message = getInvalidETagMessage(error.response?.data.message);
    if (message) {
      dispatch({ type: 'SET_INVALID_ETAG_MESSAGE', data: message });
    }
  }
};

export const parseMpiResults = (results) => {
  try {
    if (!results) return;

    // Handle unwanted additional characters at end of string
    const slicedResults = !results.slice(-2).includes('}') ? results.slice(0, -2) : results;

    // Handle special characters and quotes
    const processedResults = slicedResults
      .replace(/\\n/g, '\\n')
      .replace(/\\'/g, "\\'")
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, '\\&')
      .replace(/\\r/g, '\\r')
      .replace(/\\t/g, '\\t')
      .replace(/\\b/g, '\\b')
      .replace(/\\f/g, '\\f');

    return JSON.parse(processedResults);
  } catch (e) {
    console.error('Error parsing JSON:', e);
    return [];
  }
};

export const isNetworkError = (error) => {
  return error?.message === 'Network Error' || !error?.response;
};
